import WorkForceDefinition  from "./WorkForceDefinition.js"
export default WorkForceDefinition;